import React from 'react';
import expiredTransactionImg from '../../assets/images/expiredTransaction.gif'


const Expired = () => {

    const handleBackToProfile = (e) => {
        e.preventDefault()
        window.location.href = "/client/profile"
    }

    return (
        <>
            <div className="text-center" style={{ margin: "40px" }}>
                <img src={expiredTransactionImg} alt="forbidden" />
                <p style={{ fontSize: "20px", marginTop: "-50px" }} className="text-center"><strong>There was an issue with your onboarding. Please try again later.</strong></p>
                <button style={{ width: "150px", marginTop: "50px" }} onClick={handleBackToProfile} className="me-btn">Back to Profile</button>
            </div>
        </>
    );
}

export default Expired;